










































































import queries from '@/gql/queries.coffee'
import settings from "@/settings.coffee"

export default {
    "name": 'ConsultantStatPreview'
    "data": ()->
        return {
            "modal_opened": false,
            "stats": null,
            "my_establishments_uids": {}
            "allloaded": false
        }
    "methods":
        "fetch_data_fast": ()->
            self = this
            response = await self.$http.post(settings.graphqlApiUrl, {query: queries.get_consultant_stats_fast(self.$store.state.profile.data.uid)})
            @stats = JSON.parse(response.body.data.consultant.stats_fast)
            
        "fetch_data": ()->
            @stats = null
            
            self = @
            response = await self.$http.post(settings.graphqlApiUrl, {query: queries.get_consultant_stats(self.$store.state.profile.data.uid)})
            stats = JSON.parse(response.body.data.consultant.stats)
            stats.by_establishment = stats.by_establishment.map((item)->
                item["show_all"] = false
                return item
            )
            # keep establishments uids
            stats.by_establishment.forEach((item)->
                self.my_establishments_uids[item["uid"]] = item["name"]
            )
            

            @stats = stats
            
        "show_modal": ()->
            
            self = this
            self.modal_opened = true
            self.fetch_data().then ()->
                self.allloaded = true
    "mounted": ()->
        
        self = @
        self.fetch_data_fast()

        # listen state messages
        self.$djangows['onmodelsignals']({"modelName": "review", "appLabel": "review"}, (event)->
            
            if event.obj.establishment of self.my_establishments_uids
                self.fetch_data_fast()
        )


}
